// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__5UKs3","notes":"Notes_notes__2cb42","note":"Notes_note__3Iro9","markdown":"Notes_markdown__2B2M1"};